import { Components, Theme } from "@mui/material";

const MuiButton: Components<Theme>["MuiButton"] = {
  defaultProps: {
    style: {
      textTransform: "none",
      letterSpacing: "0.64px",
    },
  },
};

export default MuiButton;
